// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nvwc-list-item[data-v-681fe460] {\n  --mdc-list-item-graphic-size: 32px;\n  --mdc-list-item-graphic-margin: 12px;\n  --mdc-list-side-padding: 8px;\n}\nvwc-list-item[data-v-681fe460]:after {\n  border-bottom: unset;\n}\n", ""]);
// Exports
module.exports = exports;
